<template>
  <div class="background">
    <div v-if="!isForeground" class="top"
         :class="backgroundId+'top'">
    </div>

    <div v-if="!isForeground" class="bottom"
         :class="backgroundId+'bottom'"></div>

    <div v-if="!isForeground" class="decorations"
         :class="backgroundId+'backDecorations'"></div>

    <div v-if="isForeground" class="decorations"
         :class="backgroundId+'decorations'"></div>
  </div>
</template>

<script>
import log from "@/utils/logger";
import FakeFeatureFlags from "@/mixins/FakeFeatureFlags.js";
import utils from "@/utils/utils";
import {Overlay} from "@/enums/Overlay";
import {EventApi} from "sandpiper_api";

export default {
  name: "StudentPlatformBackground",
  components: {},
  inject: ["doApiRequest"],
  props: {
    schoolYear: {
      type: Number,
      required: true,
      default: 1
    },
    isForeground: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      FakeFeatureFlags: FakeFeatureFlags,
      fetchingCurrentEvent: false,
      currentEvent: null,
    }
  },
  methods:
      {
        async fetchCurrentEvent() {
          if (this.fetchingCurrentEvent) return;

          try {
            this.fetchingCurrentEvent = true;

            let currentEvent = await this.doApiRequest(() => new EventApi().getCurrentEvent());
            this.applyCurrentEvent(currentEvent);

          } catch (e) {
            log.info(e);
          } finally {
            this.fetchingCurrentEvent = false;
          }
        },
        applyCurrentEvent(currentEvent) {
          this.currentEvent = currentEvent;
        }
      },
  computed: {
    backgroundId() {
      let overlay = '';

      if (this.currentEvent !== null && this.currentEvent.name !== null) {
        overlay = this.currentEvent.name;
      } else {
        overlay = Overlay.ORIGINAL;
      }

      overlay += this.grade;

      return overlay;

    },
    grade() {
      return utils.getGradeForSchoolYear(this.schoolYear);
    }

  },
  async mounted() {

  },
  beforeUnmount: function () {

  },
  async created() {
    await this.fetchCurrentEvent();
  },
}
</script>

<style lang="scss" scoped>

.background-color-olympic {
  //background-color: rgb(176,77,67);
}

.background {
  width: 100%;
  height: min(100vh, calc(100vw * 0.5625));

  position: absolute;
  overflow: hidden;
  will-change: transform;


  .top, .bottom, .decorations {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .platform {
    position: relative;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .top {
    width: 120%;
    height: 80%;
    background-position: center;
    left: -10%;
    pointer-events: none;
  }

  .decorations {
    width: 120%;
    height: 110%;
    background-position: center;
    left: -10%;
  }

  .bottom {
    width: 150%;
    height: 36%;
    background-position: 50%;
    left: -25%;
    background-repeat: repeat-x;
  }

  //Original
  .original1top {
    background-image: url("~@/assets/image/background/bb_g1/bb_g1_wall.png");
  }

  .original1bottom {
    background-image: url("~@/assets/image/background/bb_g1/bb_g1_floor.png");
  }

  .original1backDecorations {
    background-image: url("~@/assets/image/background/bb_g1/bb_g1_cables.png");
    width: 120% !important;
    height: 112% !important;
    background-position: center !important;
    left: -3% !important;
    position: absolute;
    top: 0;
  }

  .original1decorations {
    background-image: url("~@/assets/image/background/bb_g1/bb_g1_decorations.png");
    width: 120% !important;
    height: 112% !important;
    background-position: center !important;
    left: -3% !important;
  }

  .original2top {
    background-image: url("~@/assets/image/background/bb_background.svg");
  }

  .original2bottom {
    background-image: url("~@/assets/image/background/bb_floor.svg");
  }

  .original3top {
    background-image: url("~@/assets/image/background/bb_g3/bb_g3_wall.png");
  }

  .original3bottom {
    background-image: url("~@/assets/image/background/bb_g3/bb_g3_floor.png");
  }

  .original3decorations {
    background-image: url("~@/assets/image/background/bb_g3/bb_g3_decorations.png");
  }


  //VIP olympics overlay
  .olympic1top {
    background-image: url("~@/assets/image/background/bb_background_olympic.svg");
    position: absolute !important;
  }

  .olympic1bottom {
    background-image: url("~@/assets/image/background/bb_floor_olympic.svg");
    height: 73% !important;
    top: 42% !important;
    position: absolute !important;
  }

  .olympic2top {
    background-image: url("~@/assets/image/background/bb_background_olympic.svg");
    position: absolute !important;
  }

  .olympic2bottom {
    background-image: url("~@/assets/image/background/bb_floor_olympic.svg");
    height: 73% !important;
    top: 42% !important;
    position: absolute !important;
  }

  .olympic3top {
    background-image: url("~@/assets/image/background/bb_background_olympic.svg");
    position: absolute !important;
  }

  .olympic3bottom {
    background-image: url("~@/assets/image/background/bb_floor_olympic.svg");
    height: 73% !important;
    top: 42% !important;
    position: absolute !important;
  }

  //Winter games overlay
  .winter1top {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g1_wall_ws.png");
    position: absolute !important;
  }

  .winter1bottom {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g1_floor_ws.png");
    height: 73% !important;
    top: 80% !important;
    position: absolute !important;
  }

  .winter1backDecorations {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g1_decorations_ws.png");
    width: 133% !important;
    height: 112% !important;
    background-position: center !important;
    left: -9% !important;
  }

  .winter2top {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g2_wall_ws.png");
    position: absolute !important;
  }

  .winter2bottom {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g2_floor_ws.png");
    height: 73% !important;
    top: 80% !important;
    position: absolute !important;
  }

  .winter2backDecorations {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g2_cables_ws.png");
    width: 133% !important;
    height: 107% !important;
    background-position: center !important;
    left: -9% !important;
  }

  .winter2decorations {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g2_decorations_ws.png");
    width: 133% !important;
    height: 107% !important;
    background-position: center !important;
    left: -9% !important;
  }

  .winter3top {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g3_wall_ws.png");
    position: absolute !important;
  }

  .winter3bottom {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g3_floor_ws.png");
    height: 73% !important;
    top: 80% !important;
    position: absolute !important;
  }

  .winter3backDecorations {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g3_cables_ws.png");
    width: 133% !important;
    height: 107% !important;
    background-position: center !important;
    left: -9% !important;
  }

  .winter3decorations {
    background-image: url("~@/assets/image/background/bb_g123_ws/bb_g3_decorations_ws.png");
    width: 133% !important;
    height: 107% !important;
    background-position: center !important;
    left: -9% !important;
  }


  
}

</style>